// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
export type MyDepositAddressUpdatedSubscriptionVariables = Exact<{
  walletCurrency?: string | null | undefined;
}>;


export type MyDepositAddressUpdatedSubscription = { bankingMyDepositAdded: { clientSubscriptionId: string | undefined, banking: { id: string, myCurrentAddress: { id: string, address: string | undefined, createTime: number | undefined } | undefined } | undefined } | undefined };


export const MyDepositAddressUpdatedSubscriptionDocument = gql`
    subscription MyDepositAddressUpdatedSubscription($walletCurrency: String) {
  bankingMyDepositAdded(input: {  }) {
    banking {
      id
      myCurrentAddress(currency: $walletCurrency) {
        id
        address
        createTime
      }
    }
    clientSubscriptionId
  }
}
    `;